module.exports = __webpack_public_path__ + "c95fc487-48ab-48c1-b4da-f9478f900fdb.b502014ce3e5f823e8b6.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/assets/fonts/c95fc487-48ab-48c1-b4da-f9478f900fdb.ttf
// module id = ../../../../../src/assets/fonts/c95fc487-48ab-48c1-b4da-f9478f900fdb.ttf
// module chunks = 2